import { useId, useState } from "react";
import Icon from "../Icon";
import FilaTarea from "./FilaTarea";

// Un grupo plegable (Vencidas, Hoy, Esta semana...). El encabezado es el boton que lo
// pliega: aria-expanded dice si esta abierto y la seccion se nombra con el. Si el
// servidor devuelve mas filas de las que caben (tope por grupo), el recuento sigue
// diciendo el total real.
export default function GrupoTareas({ etiqueta, total, items, abiertoInicial = false, alerta = false, detalle = "", vacio = "Nada por aquí.", ...resto }) {
  const [abierto, setAbierto] = useState(abiertoInicial);
  const id = useId();
  return (
    <section className="mt-grupo" aria-labelledby={id}>
      <button type="button" id={id} className={"mt-gh btn" + (alerta && total ? " alerta" : "")}
        aria-expanded={abierto} onClick={() => setAbierto(a => !a)}>
        <span className={"mt-chev" + (abierto ? "" : " cerrado")}>
          <Icon name="chevron-down" size={13} color="currentColor" />
        </span>
        <span className="mt-gnombre">{etiqueta}</span>
        <span className="mt-gn">{total}{detalle}</span>
      </button>
      {abierto && (items.length
        ? items.map(t => <FilaTarea key={t.id ?? `p${t.task_id}`} tarea={t} {...resto} />)
        : <div className="mt-vacio-grupo">{vacio}</div>)}
      {abierto && total > items.length && (
        <div className="mt-vacio-grupo">y {total - items.length} más.</div>
      )}
    </section>
  );
}
